import classNames from 'clsx';
import type { AnchorHTMLAttributes } from 'react';
// TODO remove after SW is migrated to React 18
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import React from 'react';

import styles from './StarsLink.module.scss';

export type Props = {
  onClick?: (e: React.MouseEvent) => void;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const StarsLink: React.FC<Props> = (props) => (
  <a {...props} className={classNames(styles.starsLink, props.className)}>
    {props.children}
  </a>
);

export default StarsLink;
